import "@hotwired/turbo-rails"
import "@rails/actioncable"
import "@rails/activestorage"
import "./channels"
import jQuery from "jquery"
import "bootstrap"
import "@fortawesome/fontawesome-free/js/all"
import AOS from "aos"
import "./home"
import "slick-carousel"

window.jQuery = jQuery
window.$ = jQuery

document.addEventListener("turbo:load", () => {
  AOS.init({
    disable: false,
    startEvent: "DOMContentLoaded",
    initClassName: "aos-init",
    animatedClassName: "aos-animate",
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,
    offset: 120,
    delay: 0,
    duration: 1000,
    easing: "ease",
    once: false,
    mirror: false,
    anchorPlacement: "top-bottom",
  })

  const goToTop = document.getElementById("go_to_top")
  if (goToTop) {
    window.onscroll = function () {
      if (window.pageYOffset > 500) {
        goToTop.classList.add("sticky")
      } else {
        goToTop.classList.remove("sticky")
      }
    }
  }

  $(".section-danhmuc .navigation .right-nav").click(function () {
    $("#danhmuc_items").animate({ scrollLeft: $("#danhmuc_items").scrollLeft() + 600 }, 500)
  })
  $(".section-danhmuc .navigation .left-nav").click(function () {
    $("#danhmuc_items").animate({ scrollLeft: $("#danhmuc_items").scrollLeft() - 600 }, 500)
  })

  $(".slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  })
})
